import { prop, propEq, uniq } from "ramda";
import { useMemo } from "react";
import { useLanguage } from "./useLanguage";

const monthFormats: Intl.DateTimeFormatOptions["month"][] = [
  "numeric",
  "short",
  "2-digit",
  "long",
  "narrow",
];

export function useDateTimeSeparators(): string[] {
  const language = useLanguage();

  return useMemo(() => {
    const parts = monthFormats.map((monthFormat) => {
      const formatter = new Intl.DateTimeFormat(language, {
        month: monthFormat,
        hour: "numeric",
      });
      const [literal, ...extraParts] = formatter
        .formatToParts()
        .filter(propEq("literal", "type"))
        .map(prop("value"))
        .map((part) => part.trim())
        .filter((part) => part.length > 0);

      if (extraParts.length) {
        throw new Error("More than one literal part found");
      }

      return literal;
    });

    return uniq(parts);
  }, [language]);
}
